import { memo } from 'react';
import { AdvancedProductsTable } from './AdvancedProductsTable';

interface Product {
  product_id: number;
  name: string;
  category: string;
  experience_category?: string;
  until_date?: string;
}

interface ProductsTabProps {
  userProducts: Product[];
  loadingProducts: boolean;
  userId: string | undefined;
  onRefresh: () => void;
  onUpdateProduct: (productId: number, date: Date | string | null) => void;
  onRemoveProduct: (productId: number) => void;
  deleteInProgress?: number;
}

export const ProductsTab = memo<ProductsTabProps>(
  ({
    userProducts,
    loadingProducts,
    userId,
    onRefresh,
    onUpdateProduct,
    onRemoveProduct,
    deleteInProgress,
  }) => {
    return (
      <AdvancedProductsTable
        userProducts={userProducts}
        loadingProducts={loadingProducts}
        userId={userId}
        onRefresh={onRefresh}
        onUpdateProduct={onUpdateProduct}
        onRemoveProduct={onRemoveProduct}
        deleteInProgress={deleteInProgress}
      />
    );
  }
);

ProductsTab.displayName = 'ProductsTab';
